// extracted by mini-css-extract-plugin
export default {"modalOverlay":"MM-z","modalContent":"NM-z","header":"OM-z","close":"PM-z"};